import { LabList } from "custom-models/frontLoader";

import {
  isForeignBodyModifier,
  isLipoma,
  isSendoutModifier,
  isTissueModifier,
  isWetMountModifier,
} from "./conditions";
import { GrossingSegment } from "./segments";
import {
  falseMarginsSegments,
  smallTissueSegments,
  softenedAndDecalcifiedSegments,
} from "./segmentsCommon";

// TODO : sc-22080 Remove this once we cut out the lab setting for this feature
export const getForeignBodyGrossingSegments = (
  lab: LabList
): GrossingSegment[] => {
  const isForeignBodyRehaulLabSettingActive =
    lab?.settings?.foreign_body_rehaul;

  if (!isForeignBodyRehaulLabSettingActive)
    return [
      {
        content:
          " Included with the specimen is a {fb_text} that measures {fb_w} cm x {fb_l} cm x {fb_h} cm. The foreign body is photographed and stored per protocol.",
        condition: (s) => s.modifierSelections.foreignBody,
      },
    ];
  return grossingSegments;
};

// An alternate set of GrossingSegments for use with the Foreign Body Protocol.
export const grossingSegments: GrossingSegment[] = [
  {
    content:
      'The specimen received [fbInOrBlank] {medium_fb} labeled with patient name and "{source}" is [fbAorAnOrBlank] [typeSpace]{type_fb} measuring {measurement_w} cm x {measurement_l} cm x {measurement_h} cm[with][subcutaneous]',
    condition: (s) => isForeignBodyModifier(s),
  },
  {
    content: " {withA}",
    condition: (s) => isForeignBodyModifier(s) && s.modifierSelections.withA,
  },
  {
    content: " {lipoma_medium}",
    condition: isLipoma,
  },
  {
    content: ".",
  },
  {
    content: " No necrosis or hemorrhage is noted.",
    condition: isLipoma,
  },
  {
    content:
      " The specimen is mounted on a glass slide and coverslipped for microscopic evaluation. ",
    condition: (s) => isForeignBodyModifier(s) && isWetMountModifier(s),
  },
  {
    content: " The specimen is photographed ",
    condition: (s) => isForeignBodyModifier(s) && isTissueModifier(s),
  },
  {
    content: "and stored per protocol.",
    condition: (s) =>
      isForeignBodyModifier(s) && isTissueModifier(s) && !isSendoutModifier(s),
  },
  {
    content: "and sent to {laboratory} for testing as {type_cassette_count}.",
    condition: (s) =>
      isForeignBodyModifier(s) && isTissueModifier(s) && isSendoutModifier(s),
  },
  {
    content:
      " Tissue is identified and measures {measurement_w} cm x {measurement_l} cm x {measurement_h} cm. The tissue is {submission} submitted for histology as {cassette_count}.",
    condition: (s) =>
      isForeignBodyModifier(s) && isTissueModifier(s) && !isSendoutModifier(s),
  },
  {
    content:
      " Tissue is identified and measures {measurement_w} cm x {measurement_l} cm x {measurement_h} cm. The tissue is {submission} submitted for histology as {type_cassette_count}.",
    condition: (s) =>
      isForeignBodyModifier(s) && isTissueModifier(s) && isSendoutModifier(s),
  },
  {
    content: " No tissue identified or submitted for routine histology.",
    condition: (s) =>
      isForeignBodyModifier(s) &&
      !isTissueModifier(s) &&
      !isSendoutModifier(s) &&
      !isWetMountModifier(s),
  },
  {
    content: " No tissue submitted for routine histology.",
    condition: (s) =>
      isForeignBodyModifier(s) &&
      !isTissueModifier(s) &&
      (isSendoutModifier(s) || isWetMountModifier(s)),
  },
  {
    content: " The specimen is photographed ",
    condition: (s) => isForeignBodyModifier(s) && !isTissueModifier(s),
  },
  {
    content: "and stored per protocol.",
    condition: (s) =>
      isForeignBodyModifier(s) && !isTissueModifier(s) && !isSendoutModifier(s),
  },
  {
    content: "and sent to {laboratory} for testing as {cassette_count}.",
    condition: (s) =>
      isForeignBodyModifier(s) && !isTissueModifier(s) && isSendoutModifier(s),
  },
  ...smallTissueSegments,
  ...falseMarginsSegments,
  ...softenedAndDecalcifiedSegments,
];

export default grossingSegments;
